import * as React from "react";

import { style, Icon } from "./Symbolicons";

export const TrashRounded = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M15.543 21.004H8.457a2.251 2.251 0 01-2.244-2.078L5.247 6.373h13.506l-.966 12.553a2.25 2.25 0 01-2.244 2.078v0z"
      clipRule="evenodd"
    ></path>
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M20.003 6.373H3.997"
    ></path>
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M9.186 2.996h5.628c.621 0 1.125.504 1.125 1.126v2.25H8.061v-2.25c0-.622.504-1.126 1.125-1.126v0z"
      clipRule="evenodd"
    ></path>
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10.5 12.158l3 2.685m-2.842.158L13.341 12"
    ></path>
  </svg>
);
